<div [ngClass]="fullscreen ? (observations.length == 1 ? 'main-observations footer-height-mid' :'main-observations footer-height-max') : 'main-observations footer-height-min'">
  <div class="title">
    <span *ngIf = "hasNewObservations">El Handover fue rechazado, ¿Podés resolver las siguientes observaciones que detalló {{ receiverName }} en {{ handover!.toAreaName }}?</span>
    <span *ngIf = "!hasNewObservations">El Handover fue rechazado por {{ receiverName }} de {{ handover!.toAreaName }}, solo indicó observaciones que deben ser atendidas por el equipo de {{isEngineerUser? 'Operaciones': 'Ingeniería'}}.</span>
    <span *ngIf = "!hasNewObservations">Para continuar el proceso debe reenviar el Handover.</span>
    <button class="button-max-min" *ngIf="!fullscreen" (click)="resizeFooter()">
      <mat-icon class="material-icons-outlined">open_in_full</mat-icon>
    </button>
    <button class="button-max-min" *ngIf="fullscreen" (click)="resizeFooter()">
      <mat-icon class="material-icons-outlined">close_fullscreen</mat-icon>
    </button>
  </div>
  <div class="grid-emitter" *ngFor="let observation of observations; let i = index;">
    <div class="grid-emitter-item grid-emitter-item1">
      <span class="observation-type">{{ observation.handoverObservationTypeDescription }}: </span>
      <span *ngIf="observation.showEmitterObservation" class="observation">"{{ observation.receiverObservation }}"</span>
      <span *ngIf="!observation.showEmitterObservation" class="observation">Sin observaciones</span>
    </div>
    <div class="grid-emitter-item grid-emitter-item2">
      <div *ngIf="observation.showEmitterObservation" class="resolution-container">
        <button class="buttons-solutions" (click)="observationSolved(i)" [disabled]="readOnlyContent">
          <mat-icon *ngIf="!observation.emitterObservationSolved" [ngClass]="{'blue-solved': !observation.emitterObservationSolved && !observation.emitterObservationNotSolved, 'gray-solved': observation.emitterObservationNotSolved }" svgIcon="check"></mat-icon>
          <span *ngIf="!observation.emitterObservationSolved" [ngClass]="{'label-solved-blue': !observation.emitterObservationSolved && !observation.emitterObservationNotSolved, 'label-solved-gray': observation.emitterObservationNotSolved, 'label-solved-green': observation.emitterObservationSolved }">Se pudo resolver</span>
          <mat-icon *ngIf="observation.emitterObservationSolved" class="green" svgIcon="check-fill-green"></mat-icon>
          <span *ngIf="observation.emitterObservationSolved" class="label-solved-green">Se pudo resolver</span>
        </button>
        <mat-form-field *ngIf="observation.emitterObservationSolved">
          <textarea matInput rows="4" maxlength="255" placeholder="Detalle resolución" [(ngModel)]="observation.emitterDescriptionObservationSolved"
            [title]="observation.emitterDescriptionObservationSolved" [disabled]="readOnlyContent"></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="grid-emitter-item grid-emitter-item3">
      <a *ngIf="viewHistoryHoType(observation.handoverObservationTypeId, observation.showEmitterObservation)" class="view-history"
        (click)="viewObservationsHistory(observation.handoverObservationTypeId)">Ver Historial</a>
    </div>
    <div class="grid-emitter-item grid-emitter-item4">
      <div *ngIf="observation.showEmitterObservation" class="resolution-container">
        <button class="buttons-solutions" (click)="observationNotSolved(i)" [disabled]="readOnlyContent">
          <mat-icon *ngIf="!observation.emitterObservationNotSolved" [ngClass]="{'blue-not-solved': !observation.emitterObservationSolved && !observation.emitterObservationNotSolved, 'gray-not-solved': observation.emitterObservationSolved }" svgIcon="close"></mat-icon>
          <span *ngIf="!observation.emitterObservationNotSolved" [ngClass]="{'label-not-solved-blue': !observation.emitterObservationSolved && !observation.emitterObservationNotSolved, 'label-not-solved-gray': observation.emitterObservationSolved, 'label-not-solved-red': observation.emitterObservationNotSolved }">No se pudo resolver</span>
          <mat-icon *ngIf="observation.emitterObservationNotSolved" class="red" svgIcon="close-fill-red"></mat-icon>
          <span *ngIf="observation.emitterObservationNotSolved" class="label-not-solved-red">No se pudo resolver</span>
        </button>
        <mat-form-field *ngIf="observation.emitterObservationNotSolved">
          <textarea matInput rows="4" maxlength="255" placeholder="Detalle resolución" [(ngModel)]="observation.emitterDescriptionObservationNotSolved"
            [title]="observation.emitterDescriptionObservationNotSolved" [disabled]="readOnlyContent"></textarea>
          <mat-hint class="alert" *ngIf="observation.emitterDescriptionObservationNotSolved == ''">
            Este campo es obligatorio.
          </mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div class="grid-item-divider">
      <mat-divider></mat-divider>
    </div>
  </div>
  <div class="grid-attachment" *ngIf = "observationAttachment.length > 0">
    <h2>Adjunto</h2>
    <div class = "attachment" *ngFor="let f of observationAttachment">
        <a
            class="attachment-link"
            href="{{dhoApiUrl}}/{{ f?.filePath }}"
            download="{{ f?.fileOriginalName }}"
            target="_blank"
        >
            {{ f?.fileOriginalName }}
        </a>
    </div>
  </div>
</div>